module.exports = __webpack_public_path__ + "img/矩形 593 拷贝@2x.5b08e5be.png";